import AccountsTable from './DemoAccountsTable'

export default AccountsTable
